import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tourDetailActions, tourDetailSelectors } from '@lialo/core/lib/pages/tourDetail';

/**
 * Custom hook to load reviews using a button.
 * @param tourCode
 */
export function useLoadReviews(
  tourCode: string
) {
  const isLoading = useSelector(tourDetailSelectors.selectIsLoadingTourRatings);
  const hasMore = useSelector(tourDetailSelectors.selectHasMoreRatings);
  const hasMoreRef = React.useRef(hasMore);
  hasMoreRef.current = hasMore;
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(tourDetailActions.resetTourRating());
    dispatch(tourDetailActions.fetchTourRatingsAsync.request(tourCode));
  }, [dispatch, tourCode]);

  const loadMore = React.useCallback(() => {
    if (hasMoreRef.current) {
      dispatch(tourDetailActions.fetchTourRatingsAsync.request(tourCode));
    }
  }, [dispatch, tourCode]);

  return [hasMore, loadMore, isLoading] as const;
}
